import { observer } from "mobx-react";
import { useAppSettingStore} from "../SettingStores/AppSettingPageStore";
import ComboboxSetter from "Views/Components/Combobox/ComboboxSetter";

export const ProviderTypeSelector: React.FunctionComponent = observer(() => {
	const { 
		creditProviderItemStore: { creditProvider, providerTypeList, updateCreditProvider }, 
	} = useAppSettingStore();
	
	const handleProviderTypeChange = (value: string) => {
		updateCreditProvider({ 
			...creditProvider,
			providerTypeId: value,
			providerTypeName: providerTypeList.find(type => type.id === value)?.name ?? "",
		});
	}

	return (
		<>
			<ComboboxSetter
				label="Provider Type"
				value={creditProvider.providerTypeId}
				setValue={handleProviderTypeChange}
				options={providerTypeList.map(value => ({
					value: value.id,
					display: value.name,
				}))}
				getOptionValue={option => option}
				isRequired
				tooltip="The type of the credit provider."
			/>
		</>
	)
})